import * as Sentry from "@sentry/react";
import { config } from "./env";

export const initSentry = (dsn: string) => {
  // We only want to initialize Sentry if there is a DSN provided
  // This typically means it will only run in production or staging where the DSN is configured
  if (!dsn) {
    if (config.isDevelopment) {
      console.log("ℹ️ Sentry is disabled (no DSN provided via Azure Key Vault).");
    }
    return;
  }

  // Determine the domain purely for tagging/identifying the app origin
  const currentDomain = window.location.hostname;

  Sentry.init({
    dsn: dsn,
    environment: config.env,
    
    // We add the domain as a tag so we can filter issues by domain in Sentry.io
    // e.g. globalcoders.app, meeting.globalcoders.app
    initialScope: {
      tags: {
        domain: currentDomain,
      },
    },

    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
      Sentry.consoleLoggingIntegration({
        levels: ['log', 'info', 'warn', 'error', 'debug', 'assert'],
      }),
    ],

    // Enable Sentry.logger sending to the Logs view
    enableLogs: true,

    // Performance Monitoring
    // In production, you might want to lower this value (e.g. 0.1 for 10% of transactions)
    tracesSampleRate: 1.0, 

    // Session Replay
    // Similarly, adjust these limits in production to save quota
    replaysSessionSampleRate: 0.1, // Sample 10% of normal sessions
    replaysOnErrorSampleRate: 1.0, // Sample 100% of sessions where an error occurs
  });

  if (config.isDevelopment) {
    console.log(`✅ Sentry initialized for domain: ${currentDomain}`);
  }
};
